import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=2d6fb7da"
import script from "./ContactDialog.vue?vue&type=script&lang=ts"
export * from "./ContactDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports